/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "utilities/Constants";
import { formatDeviceAddress } from "utilities/DeviceNameFormatter";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

const UtilsInstance = new Utils();

export class AnalyzerDNReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      scopeFirstLiveListPage: -1,
      scopeFirstOscilloscopePage: -1,
      scopeFirstBarGraphPage: -1,
      scopeFirstLogPage: -1,
      // Summary numbering control
      isFirstScopeLiveListPage: true,
      isFirstScopeOscilloscopePage: true,
      isFirstScopeBarGraphPage: true,
      isFirstScopeLogPage: true,
    };
  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getRectImage = (isFilled) => {
    if (isFilled) {
      return <Image src={`${process.env.PUBLIC_URL}/images/filled-rect.png`} style={generalInfoStyles.rectangle} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={generalInfoStyles.rectangle} />;
    }
  }

  whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  getBaudRateText = (baudRate) => {
    let baudRateKbps = baudRate / 1000;
    let baudRateMbps = baudRate / 1000000;

    // If the baud rate is greater then 1000 Kbps show it as Mbps
    if (baudRateKbps >= 1000.00) {
      return baudRateMbps.toString().replace(".", ",") + " Mbps";
    }
    else {
      return baudRateKbps.toString().replace(".", ",") + " Kbps";
    }
  }

  getAmplitudeText = (device) => {
    return (device.amplitudeMedia.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK);
  }

  getAmplitudeMinText = (device) => {
    return (device.amplitudeMinima.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK);
  }

  getTagText = (device) => {
    if (device.mestre) {
      return "-";
    }
    else {
      return device.tag;
    }
  }

  getSlaveMasterText = (isMaster) => {
    if (isMaster) {
      return Strings.MASTER_DN;
    }
    else {
      return Strings.SLAVE_DN;
    }
  }

  getStatusText = (status) => {
    if (status === Constants.GOOD) {
      return Strings.GOOD_STRING_ANALYZER_DN;
    }
    else if (status === Constants.ATTENTION) {
      return Strings.ATTENTION_STRING;
    }
    else if (status === Constants.BAD) {
      return Strings.BAD_STRING_ANALYZER_DN;
    }
    else {
      return Strings.UNKNOWN_STRING;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.HEADER_TEXT_ANALYZER_DN}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return  `${this.getDateNow()}, Página ${pageNumber} / ${totalPages}`;
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "scopeLiveList" && this.state.isFirstScopeLiveListPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstLiveListPage: pageNumber,
        isFirstScopeLiveListPage: false
      });
    }
    else if (reportPart === "scopeOscilloscope" && this.state.isFirstScopeOscilloscopePage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstOscilloscopePage: pageNumber,
        isFirstScopeOscilloscopePage: false
      });
    }
    else if (reportPart === "scopeBarGraph" && this.state.isFirstScopeBarGraphPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstBarGraphPage: pageNumber,
        isFirstScopeBarGraphPage: false
      });
    }
    else if (reportPart === "scopeLog" && this.state.isFirstScopeLogPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstLogPage: pageNumber,
        isFirstScopeLogPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    return (
      <Document
        title={Strings.REPORT_EXPORT_NAME_ANALYZER_DN}>
        {this.createGeneralInfoPage()}
        {this.createDataInfoPage()}
        {this.createSummaryPage()}
        {this.createLiveListPages()}
        {this.createOscilloscopePages()}
        {this.createBarGraphPages()}
        {this.createMonitoringLogPages()}
        {this.createDisclaimerPage()}
      </Document>
    );
  }

  // ----------------- General Information ---------------------
  createGeneralInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.GENERAL_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.CLIENT_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.PROJECT_NAME} {this.props.userInput.clientProjectName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME} {this.props.userInput.clientNetworkName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.LOCATION} {this.props.userInput.clientLocation}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_NAME} {this.props.userInput.clientCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.ACCOUNTABLE_NAME} {this.props.userInput.clientAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_ADDRESS} {this.props.userInput.clientAddress}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_CITY} {this.props.userInput.clientCity}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.COMPANY_TEL} {this.props.userInput.clientTel}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getClientImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.EXECUTING_COMPANY_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_COMPANY_NAME} {this.props.userInput.executingCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_ACCOUNTABLE_NAME} {this.props.userInput.executingAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_TEL} {this.props.userInput.executingTel}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.EXECUTING_EMAIL} {this.props.userInput.executingEmail}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getExecutorImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANNOTATIONS}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.notesSection}>
          <Text style={reusableStyles.normalText}>{this.props.userInput.notes}</Text>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.CONCLUSION}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.conclusionSection}>

          <View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM_W_RESTRICTION)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_W_RESTRICTION}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.NON_CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.NON_CONFORM}</Text>
            </View>

          </View>

          <View style={generalInfoStyles.signatureLine} />

        </View>

        {this.getPageFooter("")}

      </Page >
    );
  }

  getClientImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a client image
    if (this.props.userInput.clientImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.clientImg} />
      );
    }
  }

  getExecutorImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a executor image
    if (this.props.userInput.executorImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.executorImg} />
      );
    }
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANALYSIS_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.REDE_TAG} {this.props.tag}</Text>
        <Text style={reusableStyles.normalText}>{Strings.ANALYZER_VERSION_STRING} {Constants.TS_MONITOR_VERSION}</Text>
        <Text style={reusableStyles.normalText}>{Strings.ANALYSIS_INIT} {UtilsInstance.getMonitorInitTime(this.props.uptime, UtilsInstance)} </Text>
        <Text style={reusableStyles.normalText}>{Strings.REPORT_GENERATION} {this.getDateTimeNow()} </Text>
        <Text style={reusableStyles.normalText}>{Strings.ANALYSIS_DURATION} {UtilsInstance.formatToRelativeTime2(this.props.uptime, UtilsInstance)} </Text>

        <Text style={reusableStyles.normalText}>{Strings.BAUD_RATE_ANALYZER_DN} {this.getBaudRateText(this.props.baudRate)}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NUM_MASTERS} {this.props.masters}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NUM_SLAVES} {this.props.slaves}</Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.ETHERNET_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DN}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DN}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DN}{this.props.configData.gateway} </Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.WLAN_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DN}{this.props.wifiConfigData.wifiName}</Text>
        <Text style={reusableStyles.normalText}>{Strings.IP_DN}{this.props.wifiConfigData.wifiAddr}</Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DN}{this.props.wifiConfigData.wifiNetmask}</Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DN}{this.props.wifiConfigData.wifiGateway}</Text>

        {this.getPageFooter("")}

      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        <Text style={reusableStyles.summaryText} render={() => (
          `1. ${Strings.LIVE_LIST} ${Strings.LIVE_LIST_DOTS_ANALYZER_DN} ${this.state.scopeFirstLiveListPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `2. ${Strings.OSCILLOSCOPE} ${Strings.OSC_DOTS} ${this.state.scopeFirstOscilloscopePage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `3. ${Strings.BAR_GRAPH} ${Strings.BAR_DOTS} ${this.state.scopeFirstBarGraphPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `4. ${Strings.LOG} ${Strings.LOG_DOTS} ${this.state.scopeFirstLogPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `5. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS_ANALYZER_DN} ${totalPages}`
        )} fixed />

        {this.getPageFooter("")}

      </Page>
    );
  }

  // ----------------- Live List -----------------
  createLiveListPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        {this.getLiveListPageTitle()}

        <View style={liveListStyles.table}>
          {this.createLiveListTableHeader()}
          {this.createLiveListTable()}
        </View>

        {this.getPageFooter("scopeLiveList")}

      </Page>
    );
  }

  getLiveListPageTitle = () => {
    return (
      <Text style={liveListStyles.pageTitle} fixed>{Strings.A_LIVE_LIST_PAGE_TITLE}</Text>
    );
  }

  createLiveListTableHeader = () => {
    return (
      <View style={liveListStyles.tableRow} fixed>

        <View style={liveListStyles.addressTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={liveListStyles.tagTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={liveListStyles.ampTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.MIN_AMPLITUDE_N}</Text>
        </View>

        <View style={liveListStyles.ampTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.MEAN_AMPLITUDE_N}</Text>
        </View>

        <View style={liveListStyles.tableStatusColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.SIGNAL}</Text>
        </View>

      </View>
    );
  }

  createLiveListTable = () => {
    return (
      this.props.livelist.map(device => (
        <View style={liveListStyles.tableRow} key={device.address} wrap={false}>

          <View style={liveListStyles.addressTableCol}>
            <Text style={liveListStyles.tableCell}>{formatDeviceAddress(device.address, Strings)}</Text>
          </View>

          <View style={liveListStyles.tagTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getTagText(device)}</Text>
          </View>

          <View style={liveListStyles.ampTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getAmplitudeMinText(device)}</Text>
          </View>

          <View style={liveListStyles.ampTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getAmplitudeText(device)}</Text>
          </View>

          {this.createStatusCell(device)}
        </View>
      ))
    );
  }

  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <View style={liveListStyles.okTableStatusCol}>
          <Text style={liveListStyles.tableCell}>
            {Strings.GOOD_STRING_ANALYZER_DN}
          </Text>
        </View>
      );
    }
    else if (device.status === Constants.ATTENTION) {
      return (
        <View style={liveListStyles.attentionTableStatusCol}>
          <Text style={liveListStyles.tableCell}>
            {Strings.ATTENTION_STRING}
          </Text>
        </View>
      );
    }
    else if (device.status === Constants.BAD) {
      return (
        <View style={liveListStyles.badTableStatusCol}>
          <Text style={liveListStyles.tableCell}>
            {Strings.BAD_STRING_ANALYZER_DN}
          </Text>
        </View>
      );
    }
    else {
      return (
        <View style={liveListStyles.unknownTableStatusCol}>
          <Text style={liveListStyles.tableCell}>
            {Strings.UNKNOWN_STRING}
          </Text>
        </View>
      );
    }
  }

  createWaveStatusCell = (isWaveOk) => {
    if (isWaveOk) {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-check.png`} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-warning.png`} />;
    }
  }

  createNoiseCell = (withNoise) => {
    if (!withNoise) {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-check.png`} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-warning.png`} />;
    }
  }

  // ----------------- Oscilloscope -----------------
  createOscilloscopePages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getOscilloscopePageTitle()}

        {this.createOscilloscopeImages()}

        {this.getPageFooter("scopeOscilloscope")}
      </Page>
    );
  }

  getOscilloscopePageTitle = () => {
    return (
      <Text style={oscilloscopeStyles.pageTitle} fixed>
        {Strings.A_OSCILLOSCOPE_PAGE_TITLE}
      </Text>
    );
  }

  getOscilloscopePageTitle = () => {
    return (
      <Text style={oscilloscopeStyles.pageTitle} fixed>
        {Strings.A_OSCILLOSCOPE_PAGE_TITLE}
      </Text>
    );
  }

  createOscilloscopeImages = () => {
    return (
      this.props.imgURIs.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {this.getSlaveMasterText(this.props.livelistMap.get(data.address).isMaster)}
            </Text>
            {formatDeviceAddress(data.address, Strings)}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.SIGNAL_DN}
            </Text>
            {this.getStatusText(this.props.livelistMap.get(data.address).status)}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.AMPLITUDE_MIN_DN}
            </Text>
            {this.props.livelistMap.get(data.address).amplitudeMinima.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.MEAN_AMPLITUDE}:
            </Text>
            {" " + this.props.livelistMap.get(data.address).amplitudeMedia.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK}
          </Text>

          <Text style={oscilloscopeStyles.waveTitle}>{Strings.WAVE_DN}</Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View>
      ))
    );
  }

  // ----------------- Bar Graph -----------------
  createBarGraphPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getBarGraphPageTitle()}

        <Text style={ampStyles.waveTitle}>{Strings.MIN_AMPLITUDE}</Text>
        {this.createBarGraphMinImages()}

        <Text style={ampStyles.waveTitle}>{Strings.MEAN_AMPLITUDE}</Text>
        {this.createBarGraphAmpImages()}

        {this.getPageFooter("scopeBarGraph")}
      </Page>
    );
  }

  getBarGraphPageTitle = () => {
    return <Text style={ampStyles.pageTitle} fixed>{Strings.A_BAR_GRAPH_PAGE_TITLE}</Text>;
  }

  createBarGraphAmpImages = () => {
    return (
      this.props.ampImgURIs.map(data => (
        // eslint-disable-next-line react/jsx-key
        <Image src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  createBarGraphMinImages = () => {
    return (
      this.props.minAmpImgURIs.map(data => (
        // eslint-disable-next-line react/jsx-key
        <Image src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  // ----------------- Log -----------------
  createMonitoringLogPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={monitoringLogStyles.pageTitle} fixed>{Strings.A_LOG_PAGE_TITLE}</Text>
        <Text style={monitoringLogStyles.pageLastEventsText} fixed>{Strings.LAST_200_EVENTS}</Text>

        <View style={monitoringLogStyles.table}>
          {this.createMonitoringLogTableHeader()}
          {this.createMonitoringLogTable()}
        </View>

        {this.getPageFooter("scopeLog")}

      </Page>
    );
  }

  createMonitoringLogTableHeader = () => {
    return (
      <View style={monitoringLogStyles.tableRow} fixed>

        <View style={monitoringLogStyles.horaryTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={monitoringLogStyles.addressTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={monitoringLogStyles.tagTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={monitoringLogStyles.descriptionTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.DESCRIPTION}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLogTable = () => {
    return (
      this.props.log.map(logEntry => (
        <View wrap={false} key={logEntry.event}>
          <View style={monitoringLogStyles.tableRow} key={logEntry.event}>

            <View style={monitoringLogStyles.horaryTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.formatTime(logEntry)}</Text>
            </View>

            <View style={monitoringLogStyles.addressTableCol}>
              {logEntry.address !== undefined && logEntry.address !== null ? (
                <Text style={monitoringLogStyles.tableCell}>{formatDeviceAddress(logEntry.address, Strings)}</Text>
              ):(
                <Text style={monitoringLogStyles.tableCell}>-</Text>
              )}
            </View>

            <View style={monitoringLogStyles.tagTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.getLogTag(logEntry)}</Text>
            </View>

            <View style={monitoringLogStyles.descriptionTableCol}>
              <Text style={monitoringLogStyles.tableCell}>
                {this.getDescriptionText(logEntry)}
              </Text>
            </View>
          </View>
        </View>
      ))
    );
  }

  getLogTag = (logEntry) => {
    if (logEntry.tag === "") {
      return "-";
    }
    else {
      return logEntry.tag;
    }
  }

  getDescriptionText = (logEntry) => {
    if (logEntry.tipo === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return logEntry.active ? Strings.DN_ATTENTION_SIGNAL_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_ANALYZER_DN;
    }
    else if (logEntry.tipo  === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return logEntry.active ? Strings.DN_BAD_SIGNAL_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_ANALYZER_DN;
    }
    else if (logEntry.tipo  === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return logEntry.active ? Strings.CAPACITIVE_EFFECT_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_ANALYZER_DN;
    }
    else if (logEntry.tipo  === Constants.NOISE_PROBLEM_TYPE) {
      return logEntry.active ? Strings.NOISE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_ANALYZER_DN;
    }
    else if (logEntry.tipo  === "estado") {
      return Strings.STATUS_CHANGE + logEntry.description;
    }
  }

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      let timeNow = new Date().getTime();
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage() {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter("")}

      </Page >
    );
  }

  render() {
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginBottom: 2,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const generalInfoStyles = StyleSheet.create({

  notesSection: {
    maxWidth: "510pt",
    width: "90vw",
    height: "14vh"
  },

  conclusionSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "16vh"
  },

  rectangleSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  rectangle: {
    width: 28,
    height: 28,
    margin: "1vh vw"
  },
  signatureLine: {
    height: "1px",
    width: "40vw",
    backgroundColor: "black",
  }
});

const liveListStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
    alignItems: "center",
    justifyContent: "center"
  },

  tableRow: {
    flexDirection: "row"
  },

  addressTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  abTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ampTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableStatusColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  addressTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tagTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  abTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ampTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  okTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  attentionTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow"
  },

  badTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722"
  },

  okFadedTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
    opacity: 0.5
  },

  attentionFadedTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow",
    opacity: 0.5
  },

  badFadedTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722",
    opacity: 0.5
  },

  unknownTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lightgrey"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 10,
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 5,
    fontSize: 10,
    fontFamily: "RobotoRegular"
  }
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {

    height: "28vh",
    width: "87vw"
  }
});

const ampStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16
  },

  chartImgStyle: {
    height: "33vh",
    width: "87vw",
    marginTop: "1vh",
    marginBottom: "4vh"
  }
});

const monitoringLogStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  pageLastEventsText: {
    fontSize: 12,
    marginBottom: "3vh",
    fontFamily: "RobotoRegular"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  addressTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  descriptionTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
  },

  addressTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },

  tagTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  descriptionTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  tableCellLeft: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },
});

export default AnalyzerDNReport;
